module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "3D Models",
		"url": "/category/3d-models",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=3d-models",
				"isTop": true
			},
			{
				"name": "Anatomy",
				"url": "/category/3d-models/anatomy"
			},
			{
				"name": "Animals",
				"url": "/category/3d-models/animals"
			},
			{
				"name": "Base Meshes",
				"url": "/category/3d-models/base-meshes"
			},
			{
				"name": "Buildings and Architecture",
				"url": "/category/3d-models/buildings-and-architecture"
			},
			{
				"name": "Clothes & Accessories",
				"url": "/category/3d-models/clothes-accessories"
			},
			{
				"name": "Deco Objects",
				"url": "/category/3d-models/deco-objects"
			},
			{
				"name": "Design Elements",
				"url": "/category/3d-models/design-elements"
			},
			{
				"name": "Electronics",
				"url": "/category/3d-models/electronics"
			},
			{
				"name": "Engines and Parts",
				"url": "/category/3d-models/engines-and-parts"
			},
			{
				"name": "Fantasy and Fiction",
				"url": "/category/3d-models/fantasy-and-fiction"
			},
			{
				"name": "Food and Drinks",
				"url": "/category/3d-models/food-and-drinks"
			},
			{
				"name": "Furnishings",
				"url": "/category/3d-models/furnishings"
			},
			{
				"name": "Humans",
				"url": "/category/3d-models/humans"
			},
			{
				"name": "Music",
				"url": "/category/3d-models/music"
			},
			{
				"name": "Nature",
				"url": "/category/3d-models/nature"
			},
			{
				"name": "Products",
				"url": "/category/3d-models/products"
			},
			{
				"name": "Science",
				"url": "/category/3d-models/science"
			},
			{
				"name": "Sports",
				"url": "/category/3d-models/sports"
			},
			{
				"name": "Theme Packages",
				"url": "/category/3d-models/theme-packages"
			},
			{
				"name": "Tools",
				"url": "/category/3d-models/tools"
			},
			{
				"name": "Toys and Games",
				"url": "/category/3d-models/toys-and-games"
			},
			{
				"name": "Vehicles",
				"url": "/category/3d-models/vehicles"
			},
			{
				"name": "Weapons and Armor",
				"url": "/category/3d-models/weapons-and-armor"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/3d-models/miscellaneous"
			}
		]
	},
	{
		"name": "Cars",
		"url": "/category/3d-models/vehicles/land/cars",
		"children": []
	},
	{
		"name": "HDRI Images",
		"url": "/category/cg-textures/hdri-images",
		"children": [
			{
				"name": "Exterior",
				"url": "/category/cg-textures/hdri-images/exterior"
			},
			{
				"name": "Interior",
				"url": "/category/cg-textures/hdri-images/interior"
			},
			{
				"name": "Sky",
				"url": "/category/cg-textures/hdri-images/exterior/sky"
			}
		]
	},
	{
		"name": "CG Textures",
		"url": "/category/cg-textures",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cg-textures",
				"isTop": true
			},
			{
				"name": "Bones",
				"url": "/category/cg-textures/bones"
			},
			{
				"name": "Buildings",
				"url": "/category/cg-textures/buildings"
			},
			{
				"name": "Concrete",
				"url": "/category/cg-textures/concrete"
			},
			{
				"name": "Doors",
				"url": "/category/cg-textures/doors"
			},
			{
				"name": "Fabric",
				"url": "/category/cg-textures/fabric"
			},
			{
				"name": "Fauna",
				"url": "/category/cg-textures/fauna"
			},
			{
				"name": "Flora",
				"url": "/category/cg-textures/flora"
			},
			{
				"name": "Ground",
				"url": "/category/cg-textures/ground"
			},
			{
				"name": "HDRI Images",
				"url": "/category/cg-textures/hdri-images"
			},
			{
				"name": "Humans",
				"url": "/category/cg-textures/humans"
			},
			{
				"name": "Ice",
				"url": "/category/cg-textures/ice"
			},
			{
				"name": "Metal",
				"url": "/category/cg-textures/metal"
			},
			{
				"name": "Ornaments",
				"url": "/category/cg-textures/ornaments"
			},
			{
				"name": "Paper",
				"url": "/category/cg-textures/paper"
			},
			{
				"name": "Plaster",
				"url": "/category/cg-textures/plaster"
			},
			{
				"name": "Plastic",
				"url": "/category/cg-textures/plastic"
			},
			{
				"name": "Roads",
				"url": "/category/cg-textures/roads"
			},
			{
				"name": "Roofing",
				"url": "/category/cg-textures/roofing"
			},
			{
				"name": "Skies",
				"url": "/category/cg-textures/skies"
			},
			{
				"name": "Splatter",
				"url": "/category/cg-textures/splatter"
			},
			{
				"name": "Stone",
				"url": "/category/cg-textures/stone"
			},
			{
				"name": "Tiles",
				"url": "/category/cg-textures/tiles"
			},
			{
				"name": "Walls",
				"url": "/category/cg-textures/walls"
			},
			{
				"name": "Water",
				"url": "/category/cg-textures/water"
			},
			{
				"name": "Windows",
				"url": "/category/cg-textures/windows"
			},
			{
				"name": "Wood",
				"url": "/category/cg-textures/wood"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/cg-textures/miscellaneous"
			}
		]
	},
	{
		"name": "Materials & Shaders",
		"url": "/category/materials-and-shaders",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=materials-and-shaders",
				"isTop": true
			},
			{
				"name": "Ceramic",
				"url": "/category/materials-and-shaders/ceramic"
			},
			{
				"name": "Fabric",
				"url": "/category/materials-and-shaders/fabric"
			},
			{
				"name": "Glass",
				"url": "/category/materials-and-shaders/glass"
			},
			{
				"name": "Glow",
				"url": "/category/materials-and-shaders/glow"
			},
			{
				"name": "Marble",
				"url": "/category/materials-and-shaders/marble"
			},
			{
				"name": "Metal",
				"url": "/category/materials-and-shaders/metal"
			},
			{
				"name": "Organic",
				"url": "/category/materials-and-shaders/organic"
			},
			{
				"name": "Plastic",
				"url": "/category/materials-and-shaders/plastic"
			},
			{
				"name": "Sci-fi",
				"url": "/category/materials-and-shaders/sci-fi"
			},
			{
				"name": "Stone",
				"url": "/category/materials-and-shaders/stone"
			},
			{
				"name": "Water",
				"url": "/category/materials-and-shaders/water"
			},
			{
				"name": "Wood",
				"url": "/category/materials-and-shaders/wood"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/materials-and-shaders/miscellaneous"
			}
		]
	},
	{
		"name": "Base Meshes",
		"url": "/category/3d-models/base-meshes",
		"children": []
	},
	{
		"name": "Scripts & Plugins",
		"url": "/category/scripts-and-plugins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=scripts-and-plugins",
				"isTop": true
			},
			{
				"name": "Plugins",
				"url": "/category/scripts-and-plugins/plugins"
			},
			{
				"name": "Scripts",
				"url": "/category/scripts-and-plugins/scripts"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "2D Concepts",
				"url": "/category/2d-concepts"
			},
			{
				"name": "Animation Data",
				"url": "/category/animation-data"
			},
			{
				"name": "Render Setups",
				"url": "/category/render-setups"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/3docean.json
// module id = 225
// module chunks = 1 2